module.exports = __webpack_public_path__ + "static/media/logo.46806b00.svg";